import PropTypes from "prop-types"

const isAbsent = (value) => value === null || value === undefined || value === ""

const getDisplayValue = (value, fallback = "-") => (
    isAbsent(value) ? fallback : String(value)
)

export const getValidationResultGroups = (results, premios) => [
    {
        id: "pupar",
        gridProps: {xs: 12, md: 6},
        items: [
            {id: "pupar-calculado", label: "PUPAR Calculado", value: getDisplayValue(results.puparCalculado)},
            {id: "delta-pupar", label: "Delta", value: getDisplayValue(results.deltaPupar)},
            {id: "variacao-pupar", label: "Var%", value: getDisplayValue(results.variacaoPercentualPupar)},
        ],
    },
    {
        id: "pumtm",
        gridProps: {xs: 12, md: 6},
        items: [
            {id: "pumtm-calculado", label: "PUMTM Calculado", value: getDisplayValue(results.pumtmCalculado)},
            {id: "delta-pumtm", label: "Delta", value: getDisplayValue(results.deltaPumtm)},
            {id: "variacao-pumtm", label: "Var%", value: getDisplayValue(results.variacaoPercentualPumtm)},
        ],
    },
    {
        id: "emissao",
        gridProps: {xs: 12, md: 4},
        items: [
            {id: "spread-emissao", label: "Spread Emissão", value: getDisplayValue(results.spreadEmissao)},
            {id: "prazo-medio-emissao", label: "Prazo Médio Emissão", value: getDisplayValue(results.prazoMedioEmissao)},
        ],
    },
    {
        id: "premios",
        gridProps: {xs: 12, md: 4},
        items: [
            {id: "premio-recompra", label: "Prêmio de Recompra", value: getDisplayValue(premios.recompra.valor, "N/A")},
            {id: "premio-conversibilidade", label: "Prêmio de Conversibilidade", value: getDisplayValue(premios.conversibilidade.valor, "N/A")},
        ],
    },
    {
        id: "duration",
        gridProps: {xs: 12, md: 4},
        items: [
            {id: "percentual-pupar", label: "%PUPAR", value: getDisplayValue(results.percentualPupar)},
            {id: "duration-modificada", label: "Duration Modificada", value: getDisplayValue(results.durationModificada)},
            {id: "duration-macaulay", label: "Duration Macaulay", value: getDisplayValue(results.durationMacaulay)},
        ],
    },
]

export const validationResultGroupsPropType = PropTypes.arrayOf(
    PropTypes.shape({
        id: PropTypes.string.isRequired,
        gridProps: PropTypes.object.isRequired,
        items: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        })).isRequired,
    })
)
